// 电竞助手 App 内嵌 WebView 的 UA 标识：
//   <系统 UA> DJZS/1.2.3 (platform=ios; os=17.2; device=iPhone15,2; build=45; channel=official)
// 括号内为 `key=value; ` 键值对，后续新增字段只会追加，解析按键取值，不依赖顺序。

const UA_PATTERN = /DJZS\/(\S+) \(([^)]*)\)/;

/**
 * @returns {{version:string, platform:string, os:string, device:string, build:string, channel:string}|null}
 *   非 App 环境返回 null。
 */
export function parseAppInfo(ua) {
  const match = UA_PATTERN.exec(ua || '');
  if (!match) return null;
  const info = { version: match[1] };
  match[2].split(';').forEach((pair) => {
    const idx = pair.indexOf('=');
    if (idx > 0) info[pair.slice(0, idx).trim()] = pair.slice(idx + 1).trim();
  });
  return info;
}

export const appInfo = typeof navigator === 'undefined' ? null : parseAppInfo(navigator.userAgent);
